/**
 * Capitalize
 * @param string
 * @returns {string}
 */
export default (string) => {
  return string !== null ? string.charAt(0).toUpperCase() + string.slice(1).toLowerCase() : false;
};
